"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTransferType = exports.OrderPaymentStatus = exports.ORDERS_LIMIT = exports.OrderTypeCode = exports.NotificationType = exports.NotificationMode = exports.RejectionReason = exports.VoidReason = exports.OrderItemStatus = exports.OrderStatus = exports.OrderAction = void 0;
var OrderAction;
(function (OrderAction) {
    OrderAction["ORDER_INITIATE"] = "ORDER_INITIATE";
    OrderAction["ORDER_ASSIGN_ORDER_TYPE"] = "ORDER_ASSIGN_ORDER_TYPE";
    OrderAction["ORDER_ASSIGN_TABLE"] = "ORDER_ASSIGN_TABLE";
    OrderAction["ORDER_ASSIGN_TABLES"] = "ORDER_ASSIGN_TABLES";
    OrderAction["ORDER_TABLE_CHECK"] = "ORDER_TABLE_CHECK";
    OrderAction["ORDER_UPDATE_ORDER_NOTES"] = "ORDER_UPDATE_ORDER_NOTES";
    OrderAction["ORDER_UPDATE_FULFILMENT_DETAIL"] = "ORDER_UPDATE_FULFILMENT_DETAIL";
    OrderAction["ORDER_ASSIGN_STAFF"] = "ORDER_ASSIGN_STAFF";
    OrderAction["ORDER_ASSIGN_CUSTOMER"] = "ORDER_ASSIGN_CUSTOMER";
    OrderAction["ORDER_UPDATE_CUSTOMER"] = "ORDER_UPDATE_CUSTOMER";
    OrderAction["ORDER_UNASSIGN_CUSTOMER"] = "ORDER_UNASSIGN_CUSTOMER";
    OrderAction["ORDER_UNASSIGN_TABLE"] = "ORDER_UNASSIGN_TABLE";
    OrderAction["ORDER_ASSIGN_NAME"] = "ORDER_ASSIGN_NAME";
    OrderAction["ORDER_TRANSFER"] = "ORDER_TRANSFER";
    OrderAction["ORDER_PRINT"] = "ORDER_PRINT";
    OrderAction["ORDER_EMAIL_RECEIPT"] = "ORDER_EMAIL_RECEIPT";
    OrderAction["ORDER_ADD_DISCOUNT"] = "ORDER_ADD_DISCOUNT";
    OrderAction["ORDER_ASSIGN_RESERVATION"] = "ORDER_ASSIGN_RESERVATION";
    OrderAction["ORDER_UNASSIGN_RESERVATION"] = "ORDER_UNASSIGN_RESERVATION";
    OrderAction["ORDER_ADD_ADJUSTMENT"] = "ORDER_ADD_ADJUSTMENT";
    OrderAction["ORDER_REMOVE_ADJUSTMENTS"] = "ORDER_REMOVE_ADJUSTMENTS";
    OrderAction["ORDER_PAYMENT"] = "ORDER_PAYMENT";
    OrderAction["ORDER_PAYMENT_PROCESSED"] = "ORDER_PAYMENT_PROCESSED";
    OrderAction["ORDER_ADD_TIP"] = "ORDER_ADD_TIP";
    OrderAction["ORDER_UPDATE_TIP"] = "ORDER_UPDATE_TIP";
    OrderAction["ORDER_SAVE"] = "ORDER_SAVE";
    OrderAction["ORDER_VOID"] = "ORDER_VOID";
    OrderAction["ORDER_REFUND"] = "ORDER_REFUND";
    OrderAction["ORDER_UPDATE_LAST_CHECK"] = "ORDER_UPDATE_LAST_CHECK";
    OrderAction["ORDER_FAIL"] = "ORDER_FAIL";
    OrderAction["ORDER_UPDATE_ADJUSTMENTS"] = "ORDER_UPDATE_ADJUSTMENTS";
    OrderAction["ORDER_ITEMS_UPDATE_ADJUSTMENT"] = "ORDER_ITEMS_UPDATE_ADJUSTMENT";
    OrderAction["ORDER_ITEM_ADD"] = "ORDER_ITEM_ADD";
    OrderAction["ORDER_ITEM_REMOVE"] = "ORDER_ITEM_REMOVE";
    OrderAction["ORDER_ITEM_ADD_NOTES"] = "ORDER_ITEM_ADD_NOTES";
    OrderAction["ORDER_ITEM_UPDATE_PRICE"] = "ORDER_ITEM_UPDATE_PRICE";
    OrderAction["ORDER_ITEM_UPDATE_QUANTITY"] = "ORDER_ITEM_UPDATE_QUANTITY";
    OrderAction["ORDER_ITEM_HOLD"] = "ORDER_ITEM_HOLD";
    OrderAction["ORDER_ITEM_ADD_MODIFIER"] = "ORDER_ITEM_ADD_MODIFIER";
    OrderAction["ORDER_ITEM_REMOVE_MODIFIER"] = "ORDER_ITEM_REMOVE_MODIFIER";
    OrderAction["ORDER_ITEM_UPDATE_MODIFIER_QUANTITY"] = "ORDER_ITEM_UPDATE_MODIFIER_QUANTITY";
    OrderAction["ORDER_ITEM_PRINT"] = "ORDER_ITEM_PRINT";
    OrderAction["ORDER_ITEM_TRANSFER"] = "ORDER_ITEM_TRANSFER";
    OrderAction["ORDER_ITEM_REFUND"] = "ORDER_ITEM_REFUND";
    OrderAction["ORDER_REPLACE_VARIANT"] = "ORDER_REPLACE_VARIANT";
    OrderAction["ORDER_SWITCH_COURSE_ITEM"] = "ORDER_SWITCH_COURSE_ITEM";
    OrderAction["ORDER_ITEM_SPLIT_QUANTITY"] = "ORDER_ITEM_SPLIT_QUANTITY";
    OrderAction["ORDER_ITEM_ADD_COMBO"] = "ORDER_ITEM_ADD_COMBO";
    // ORDER REWARD
    OrderAction["ORDER_REWARD_ADD"] = "ORDER_REWARD_ADD";
    OrderAction["ORDER_REWARD_REMOVE"] = "ORDER_REWARD_REMOVE";
    OrderAction["ORDER_REWARD_UPDATE_QUANTITY"] = "ORDER_REWARD_UPDATE_QUANTITY";
    OrderAction["ORDER_REWARD_RESET"] = "ORDER_REWARD_RESET";
    OrderAction["ORDER_REWARD_ADD_SNAPSHOT"] = "ORDER_REWARD_ADD_SNAPSHOT";
    // Retrofit, TODO: Remove once POS App is cleaned up
    OrderAction["ORDER_ADD_VARIANT"] = "ORDER_ADD_VARIANT";
    OrderAction["ORDER_SELECT_CART_PRODUCT"] = "ORDER_SELECT_CART_PRODUCT";
    OrderAction["ORDER_DESELECT_CART_PRODUCT"] = "ORDER_DESELECT_CART_PRODUCT";
    // Allergens
    OrderAction["ORDER_SET_ALLERGENS"] = "ORDER_SET_ALLERGENS";
    // Used to send order sale receipt email to customer's email address
    OrderAction["CUSTOMER_NOTIFICATION"] = "CUSTOMER_NOTIFICATION";
    OrderAction["ORDER_REFUND_INITIATE"] = "ORDER_REFUND_INITIATE";
    OrderAction["ORDER_REFUND_PAYMENT"] = "ORDER_REFUND_PAYMENT";
    OrderAction["ORDER_REFUND_ITEMS"] = "ORDER_REFUND_ITEMS";
    OrderAction["ORDER_REFUND_AMOUNT"] = "ORDER_REFUND_AMOUNT";
    OrderAction["ORDER_REFUND_UPDATE"] = "ORDER_REFUND_UPDATE";
    OrderAction["ORDER_ASSIGN_REFUND_REASON"] = "ORDER_ASSIGN_REFUND_REASON";
    OrderAction["ORDERS_REFETCH"] = "ORDERS_REFETCH";
    OrderAction["ORDER_UPDATE_SEAT_NUMBER"] = "ORDER_UPDATE_SEAT_NUMBER";
    // merge
    OrderAction["ORDER_INITIATE_MERGE"] = "ORDER_INITIATE_MERGE";
    OrderAction["ORDER_MERGED"] = "ORDER_MERGED";
    // Online Order Events
    OrderAction["ORDER_INITIATE_ONLINE"] = "ORDER_INITIATE_ONLINE";
    OrderAction["ORDER_ACCEPT"] = "ORDER_ACCEPT";
    OrderAction["ORDER_REJECT"] = "ORDER_REJECT";
    OrderAction["ORDER_FIRE_ITEMS"] = "ORDER_FIRE_ITEMS";
    OrderAction["ORDER_PRINT_KITCHEN_DOCKET"] = "ORDER_PRINT_KITCHEN_DOCKET";
    OrderAction["ORDER_PARTNER_CANCEL"] = "ORDER_PARTNER_CANCEL";
    OrderAction["ORDER_COMPLETE"] = "ORDER_COMPLETE";
    OrderAction["ORDER_PLACED"] = "ORDER_PLACED";
    OrderAction["ORDER_DUPLICATE"] = "ORDER_DUPLICATE";
    OrderAction["ON_ACCOUNT_PAYMENT_TYPE"] = "On Account";
    // CDS order event specific
    OrderAction["ORDER_CLOSE"] = "ORDER_CLOSE";
    OrderAction["ORDER_OPEN"] = "ORDER_OPEN";
    // Hold print
    OrderAction["ORDER_HOLD"] = "ORDER_HOLD";
    OrderAction["REMOVE_ORDER_HOLD"] = "REMOVE_ORDER_HOLD";
    // Transfer order items
    OrderAction["ORDER_TRANSFER_ITEMS"] = "ORDER_TRANSFER_ITEMS";
    OrderAction["ORDER_TRANSFERRED_ITEMS"] = "ORDER_TRANSFERRED_ITEMS";
    OrderAction["ORDER_TRANSFER_TABLES"] = "ORDER_TRANSFER_TABLES";
    // checkout order locking
    OrderAction["ORDER_LOCK"] = "ORDER_LOCK";
    OrderAction["ORDER_UNLOCK"] = "ORDER_UNLOCK";
    // course specific
    OrderAction["ORDER_COURSE_CALLED"] = "ORDER_COURSE_CALLED";
    OrderAction["ORDER_COURSE_UNCALLED"] = "ORDER_COURSE_UNCALLED";
})(OrderAction = exports.OrderAction || (exports.OrderAction = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DRAFT"] = "DRAFT";
    OrderStatus["CREATED"] = "CREATED";
    OrderStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OrderStatus["VOID"] = "VOID";
    OrderStatus["REFUNDED"] = "REFUNDED";
    OrderStatus["COMPLETED"] = "COMPLETED";
    OrderStatus["ON_HOLD"] = "ON_HOLD";
    OrderStatus["ON_ACCOUNT"] = "ON_ACCOUNT";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["PARTNER_CANCELLED"] = "PARTNER_CANCELLED";
    OrderStatus["MERGED"] = "MERGED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderItemStatus;
(function (OrderItemStatus) {
    OrderItemStatus["DRAFT"] = "DRAFT";
    OrderItemStatus["CREATED"] = "CREATED";
    OrderItemStatus["CANCELLED"] = "CANCELLED";
    OrderItemStatus["ON_HOLD"] = "ON_HOLD";
    OrderItemStatus["REFUNDED"] = "REFUNDED";
    OrderItemStatus["COMPLETED"] = "COMPLETED";
    OrderItemStatus["VOID"] = "VOID";
    OrderItemStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OrderItemStatus["MERGED"] = "MERGED";
    OrderItemStatus["TRANSFERRED"] = "TRANSFERRED";
})(OrderItemStatus = exports.OrderItemStatus || (exports.OrderItemStatus = {}));
var VoidReason;
(function (VoidReason) {
    VoidReason["WRONG_ORDER"] = "WRONG_ORDER";
    VoidReason["CUSTOMER_UNHAPPY"] = "CUSTOMER_UNHAPPY";
    VoidReason["CHANGE_OF_MIND"] = "CHANGE_OF_MIND";
    VoidReason["NOT_PREPARED"] = "NOT_PREPARED";
    VoidReason["STAFF_ERROR"] = "STAFF_ERROR";
    VoidReason["WASTAGE"] = "WASTAGE";
    VoidReason["LOST_TABLE"] = "LOST_TABLE";
    VoidReason["FOOD_TASTING"] = "FOOD_TASTING";
    VoidReason["PRODUCT_DAMAGED"] = "PRODUCT_DAMAGED";
    VoidReason["WRONG_PRODUCT"] = "WRONG_PRODUCT";
    VoidReason["PRODUCT_EXCHANGED"] = "PRODUCT_EXCHANGED";
    VoidReason["TESTING_OR_TRAINING"] = "TESTING_OR_TRAINING";
    VoidReason["COMPLIMENTARY"] = "COMPLIMENTARY";
    VoidReason["OTHER"] = "OTHER";
})(VoidReason = exports.VoidReason || (exports.VoidReason = {}));
var RejectionReason;
(function (RejectionReason) {
    RejectionReason["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    RejectionReason["CLOSED"] = "CLOSED";
    RejectionReason["TOO_BUSY"] = "TOO_BUSY";
    RejectionReason["TOO_FAR_AWAY"] = "TOO_FAR_AWAY";
    RejectionReason["INVALID_ITEM"] = "INVALID_ITEM";
    RejectionReason["INVALID_ITEM_SURCOUNT"] = "INVALID_ITEM_SURCOUNT";
    RejectionReason["INVALID_ITEM_OPTION"] = "INVALID_ITEM_OPTION";
    RejectionReason["INVALID_ITEM_VARIANT"] = "INVALID_ITEM_VARIANT";
    RejectionReason["INVALID_ORDER_SURCOUNT"] = "INVALID_ORDER_SURCOUNT";
    RejectionReason["WRONG_ITEM_PRICE"] = "WRONG_ITEM_PRICE";
    RejectionReason["WRONG_ITEM_TOTAL_BEFORE_SURCOUNTS"] = "WRONG_ITEM_TOTAL_BEFORE_SURCOUNTS";
    RejectionReason["WRONG_ITEM_TOTAL_AFTER_SURCOUNTS"] = "WRONG_ITEM_TOTAL_AFTER_SURCOUNTS";
    RejectionReason["WRONG_ITEM_SURCOUNT_VALUE"] = "WRONG_ITEM_SURCOUNT_VALUE";
    RejectionReason["WRONG_ITEM_VARIANT_VALUE"] = "WRONG_ITEM_VARIANT_VALUE";
    RejectionReason["WRONG_ORDER_SURCOUNT_VALUE"] = "WRONG_ORDER_SURCOUNT_VALUE";
})(RejectionReason = exports.RejectionReason || (exports.RejectionReason = {}));
var NotificationMode;
(function (NotificationMode) {
    NotificationMode["EMAIL_AND_PHONE"] = "EMAIL_AND_PHONE";
    NotificationMode["EMAIL"] = "EMAIL";
    NotificationMode["PHONE"] = "PHONE";
})(NotificationMode = exports.NotificationMode || (exports.NotificationMode = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["SEND_RECEIPT_AND_MESSAGE"] = "SEND_RECEIPT_AND_MESSAGE";
    NotificationType["SEND_RECEIPT"] = "SEND_RECEIPT";
    NotificationType["SEND_MESSAGE"] = "SEND_MESSAGE";
    NotificationType["SEND_KDS_MESSAGE"] = "SEND_KDS_MESSAGE";
    NotificationType["SEND_ORDER_STATUS_UPDATE"] = "SEND_ORDER_STATUS_UPDATE";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var OrderTypeCode;
(function (OrderTypeCode) {
    OrderTypeCode["CATERING"] = "C";
    OrderTypeCode["DELIVERY"] = "DL";
    OrderTypeCode["DINE_IN"] = "D";
    OrderTypeCode["PICK_UP"] = "P";
    OrderTypeCode["TAKEAWAY"] = "T";
})(OrderTypeCode = exports.OrderTypeCode || (exports.OrderTypeCode = {}));
exports.ORDERS_LIMIT = 50;
var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus["REQUESTED"] = "REQUESTED";
    OrderPaymentStatus["PENDING"] = "PENDING";
    OrderPaymentStatus["PART_PAID"] = "PART_PAID";
    OrderPaymentStatus["WAITING"] = "WAITING";
    OrderPaymentStatus["CANCELLED"] = "CANCELLED";
    OrderPaymentStatus["REJECTED"] = "REJECTED";
    OrderPaymentStatus["REFUND_IN_PROGRESS"] = "REFUND_IN_PROGRESS";
    OrderPaymentStatus["SENT_FOR_REFUND"] = "SENT_FOR_REFUND";
    OrderPaymentStatus["REFUND_FAILED"] = "REFUND_FAILED";
    OrderPaymentStatus["COMPLETE"] = "COMPLETE";
})(OrderPaymentStatus = exports.OrderPaymentStatus || (exports.OrderPaymentStatus = {}));
var OrderTransferType;
(function (OrderTransferType) {
    OrderTransferType["ITEMS"] = "ITEMS";
    OrderTransferType["TABLES"] = "TABLES";
})(OrderTransferType = exports.OrderTransferType || (exports.OrderTransferType = {}));
//# sourceMappingURL=orders.js.map